<template>
<div :class="bem()">
    <div :class="bem('header')" @click="backLogin">
        <img src="https://cdn.dancf.com/fe-assets/20220412/0614eb42b3f688326274cf39822a3fa3.svg" alt="">
        <span>返回登录</span>
    </div>
    <div :class="bem('content')">
        <img src="http://gd-file-manage-test.dancf.com/saas/v0v37d/fd486eb4-8f87-403f-b9f5-84115d642acf187.svg" alt="">
        <p :class="bem('title')">您尚未创建或加入任何企业</p>
        <div :class="bem('desc')">
            <p>所在企业已开通账号，请联系「企业管理员」将您加入企业或开启企业微信授权登录方式<br/>若无已开通账号，请点击「开通免费试用」<br/>若您通过第三方账号登录后无法进入原来的企业 ，可能是由于稿定账号体系升级导致，请尝试使用手机号登录，其他疑问请联系「客服」</p>
        </div>
        <Button
            :class="bem('btn-open')"
            type="primary"
            @click="open">
            开通免费试用
        </Button>
    </div>
</div>

</template>
<script>
import _Button from "@gaoding/gdui/lib/button";
import bemMixin from './bem';
import { getConfig } from './config';
export default {
  name: 'g-auth-breaklogin-qiye',
  components: {
    Button: _Button
  },
  mixins: [bemMixin],
  inject: ['vm'],
  data: function data() {
    return {};
  },
  methods: {
    backLogin: function backLogin() {
      this.vm.switchType('wechat');
    },
    open: function open() {
      var gdUrl = getConfig('gaodingURL');
      window.open("".concat(gdUrl, "/qiye/introduction"), "_blank");
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-breaklogin-qiye__header {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  margin: 24px 0 0 24px;
  line-height: 0;
  font-weight: 500;
  cursor: pointer;
}
.g-auth-breaklogin-qiye__content {
  position: absolute;
  top: 69px;
  left: 0;
  right: 0;
  text-align: center;
}
.g-auth-breaklogin-qiye__content img {
  width: 140px;
  height: 140px;
}
.g-auth-breaklogin-qiye__title {
  margin: 12px 0 0;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
}
.g-auth-breaklogin-qiye__desc {
  margin: 12px 40px 0;
  font-size: 12px;
  line-height: 18px;
  color: #636C78;
  text-align: left;
}
.g-auth-breaklogin-qiye__btn-open {
  width: 240px;
  margin-top: 30px;
}

</style>
